import mixpanel from "mixpanel-browser";
import { Urls } from "../Urls";
// import { UserDetailsContext } from "../UserDetailsContext";
import { useContext } from "react";
// import { UserApiContext, UserDetailsContext } from "../Components/UserDetailsContext/UserDetailsContext";
// import { MyCompanyProfileContext } from "../MyCompanyProfileContext";
// import { MyCompanyProfileContext } from "../MyCompanyProfileContext";

export const useMixPanelForTracking = (userDetails, companySettingData) => {
  //   const {userDetails} = useContext(UserDetailsContext);
  // const { userDetails } = useContext(UserApiContext);
  // const { companySettingData } = useContext(MyCompanyProfileContext);
  const TrackMixPanel = ({
    ModuleName,
    ScreenName,
    Data = "None",
    Definition,
    optionalData= null
  }) => {
    mixpanel.track(Definition, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ModuleName: ModuleName,
      ScreenName: ScreenName,
      ClientIP: sessionStorage.getItem("ClientIP"),
      Data: Data,
      UserName: userDetails?.user_name || "",
      UserEmail:
       optionalData ?? userDetails?.email ?? "",
      CompanyName: companySettingData?.company_name || "",
    });
  };

  return { TrackMixPanel };
};
